"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionCarrierCouplesConsentsResponseDtoToJSON = exports.RequisitionCarrierCouplesConsentsResponseDtoFromJSONTyped = exports.RequisitionCarrierCouplesConsentsResponseDtoFromJSON = exports.instanceOfRequisitionCarrierCouplesConsentsResponseDto = exports.RequisitionCarrierCouplesConsentsResponseDtoSummaryStatusEnum = exports.RequisitionCarrierCouplesConsentsResponseDtoConsentLocationEnum = exports.RequisitionCarrierCouplesConsentsResponseDtoSourceEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.RequisitionCarrierCouplesConsentsResponseDtoSourceEnum = {
    Patient: 'PATIENT',
    Physician: 'PHYSICIAN'
};
/**
 * @export
 */
exports.RequisitionCarrierCouplesConsentsResponseDtoConsentLocationEnum = {
    Trf: 'TRF',
    Portal: 'PORTAL',
    Verbal: 'VERBAL',
    RequestForm: 'REQUEST_FORM',
    Emr: 'EMR'
};
/**
 * @export
 */
exports.RequisitionCarrierCouplesConsentsResponseDtoSummaryStatusEnum = {
    Requested: 'requested',
    RequiresReview: 'requires_review',
    CannotBeGenerated: 'cannot_be_generated',
    Generated: 'generated'
};
/**
 * Check if a given object implements the RequisitionCarrierCouplesConsentsResponseDto interface.
 */
function instanceOfRequisitionCarrierCouplesConsentsResponseDto(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "dateGranted" in value;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
exports.instanceOfRequisitionCarrierCouplesConsentsResponseDto = instanceOfRequisitionCarrierCouplesConsentsResponseDto;
function RequisitionCarrierCouplesConsentsResponseDtoFromJSON(json) {
    return RequisitionCarrierCouplesConsentsResponseDtoFromJSONTyped(json, false);
}
exports.RequisitionCarrierCouplesConsentsResponseDtoFromJSON = RequisitionCarrierCouplesConsentsResponseDtoFromJSON;
function RequisitionCarrierCouplesConsentsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'requisitionId': !(0, runtime_1.exists)(json, 'requisition_id') ? undefined : json['requisition_id'],
        'partnerRequisitionId': !(0, runtime_1.exists)(json, 'partner_requisition_id') ? undefined : json['partner_requisition_id'],
        'partnerEmail': !(0, runtime_1.exists)(json, 'partner_email') ? undefined : json['partner_email'],
        'dateGranted': json['date_granted'],
        'dateRevoked': !(0, runtime_1.exists)(json, 'date_revoked') ? undefined : json['date_revoked'],
        'source': json['source'],
        'consentLocation': !(0, runtime_1.exists)(json, 'consent_location') ? undefined : json['consent_location'],
        'summaryStatus': !(0, runtime_1.exists)(json, 'summary_status') ? undefined : json['summary_status'],
    };
}
exports.RequisitionCarrierCouplesConsentsResponseDtoFromJSONTyped = RequisitionCarrierCouplesConsentsResponseDtoFromJSONTyped;
function RequisitionCarrierCouplesConsentsResponseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'requisition_id': value.requisitionId,
        'partner_requisition_id': value.partnerRequisitionId,
        'partner_email': value.partnerEmail,
        'date_granted': value.dateGranted,
        'date_revoked': value.dateRevoked,
        'source': value.source,
        'consent_location': value.consentLocation,
        'summary_status': value.summaryStatus,
    };
}
exports.RequisitionCarrierCouplesConsentsResponseDtoToJSON = RequisitionCarrierCouplesConsentsResponseDtoToJSON;
